import { enumObject, EnumObjectValue } from '@app/base';

export const NotificationType = enumObject('NotificationType', [
  'AppointmentCreatedByPatient',
  'AppointmentCreatedByProvider',
  'AppointmentCancelledByProvider',
  'AppointmentCancelledByPatient',
  'FileSharedWithPatient',
  'TreatmentPlanEditRequest',
  'DocumentSignRequired',
  'VisitScheduledPerformer',
  'VisitScheduledCoordinator',
  'VisitScheduledCareHomeStaff',
  'VisitScheduledPatient',
  'VisitCancelledPerformer',
  'VisitCancelledCoordinator',
  'VisitCancelledCareHomeStaff',
  'VisitCancelledPatient',
  'VisitRequestedCoordinator',
  'ConsentFormSignedPerformer',
  'ConsentFormSignedCoordinator',
  'ConsentFormAssignedPatient',
  'ConsentFormAssignedCareHomeStaff',
  'VisitDueInFourteenDaysPatient',
  'VisitDueInTwoDaysPatient',
  'VisitDueInOneDayPatient',
  'VisitDueInFourteenDaysCareHomeStaff',
  'VisitDueInTwoDaysCareHomeStaff',
  'VisitDueInOneDayCareHomeStaff',
  'ChatMessageReceived',
] as const);
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type NotificationType = EnumObjectValue<typeof NotificationType>;

export interface NotificationSetting {
  type: NotificationType;
  internal: boolean;
  email: boolean;
}

export const PATIENT_NOTIFICATION_TYPES = [
  NotificationType.VisitScheduledPatient,
  NotificationType.VisitCancelledPatient,
  NotificationType.FileSharedWithPatient,
  NotificationType.ConsentFormAssignedPatient,
  NotificationType.VisitDueInFourteenDaysPatient,
  NotificationType.VisitDueInTwoDaysPatient,
  NotificationType.VisitDueInOneDayPatient,
  NotificationType.ChatMessageReceived,
];

export const PERFORMER_NOTIFICATION_TYPES = [
  NotificationType.VisitScheduledPerformer,
  NotificationType.VisitCancelledPerformer,
  NotificationType.ConsentFormSignedPerformer,
  NotificationType.ChatMessageReceived,
];

export const COORDINATOR_NOTIFICATION_TYPES = [
  NotificationType.VisitRequestedCoordinator,
  NotificationType.VisitScheduledCoordinator,
  NotificationType.VisitCancelledCoordinator,
  NotificationType.ConsentFormSignedCoordinator,
  NotificationType.ChatMessageReceived,
];

export const CARE_HOME_STAFF_NOTIFICATION_TYPES = [
  NotificationType.VisitScheduledCareHomeStaff,
  NotificationType.VisitCancelledCareHomeStaff,
  NotificationType.ConsentFormAssignedCareHomeStaff,
  NotificationType.VisitDueInFourteenDaysCareHomeStaff,
  NotificationType.VisitDueInTwoDaysCareHomeStaff,
  NotificationType.VisitDueInOneDayCareHomeStaff,
  NotificationType.ChatMessageReceived,
];

export const EMPLOYEE_NOTIFICATION_TYPES = Array.from(
  new Set<NotificationType>([
    ...PERFORMER_NOTIFICATION_TYPES,
    ...COORDINATOR_NOTIFICATION_TYPES,
    ...CARE_HOME_STAFF_NOTIFICATION_TYPES,
  ]),
);
